import { Firestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { Availability } from '@models';

import { BaseService } from '../base/base.service';

import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class AvailabilityService extends BaseService<Availability> {
  protected readonly documentPath = 'availabilities';

  constructor(
    protected db: Firestore,
    protected toastService: ToastService
  ) {
    super(db, toastService);
  }
}
